// 2_components/cbox.js
// Colorbox: no elastic transition, outside-click close, and mark Hlídat /
// Zeptat se before AJAX so the centered shell applies from open (no side jump).
// Packeta / .logistics-modal is left alone.

const CONTENT_MODAL_CLASS = "nat-content-modal";
const CONTENT_MODAL_TRIGGER = "a.link-icon.watchdog, a.link-icon.chat";

let pendingContentModal = false;

export function init() {
	const $ = window.jQuery;
	const colorbox = $?.colorbox;
	if (!colorbox?.settings) return;

	colorbox.settings.transition = "none";
	document.addEventListener("click", closeOnOutsideClick);
	document.addEventListener("click", markPendingContentModal, true);

	$(document).on("cbox_open cbox_complete", applyContentModalClass);
	$(document).on("cbox_cleanup cbox_closed", clearContentModalClass);
}

function markPendingContentModal(event) {
	const target = event.target;
	if (!(target instanceof Element)) return;
	if (!target.closest(CONTENT_MODAL_TRIGGER)) return;
	pendingContentModal = true;
}

function applyContentModalClass() {
	if (!pendingContentModal) return;
	document.querySelector("#colorbox")?.classList.add(CONTENT_MODAL_CLASS);
}

function clearContentModalClass() {
	pendingContentModal = false;
	document.querySelector("#colorbox")?.classList.remove(CONTENT_MODAL_CLASS);
}

function closeOnOutsideClick(event) {
	const target = event.target;
	if (!target.isConnected || !target.closest("#colorbox") || target.closest("#cboxContent")) return;

	window.jQuery.colorbox.close();
}
